import React, { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { prefix } from '../../config';

function Nav({ className, item }) {
    const { brand = {}, btn, links, toggle } = item;
    const btnRef = useRef();
    const navRef = useRef();

    const renderBrand = () => {
        return (
            <a href="#">
                <img
                    src={brand.logo || './assets/images/logo-placeholder.png'}
                    alt={brand.logoAlt}
                    width={brand.style?.width}
                />
            </a>
        );
    };
    const renderIcon = (icon) => {
        return icon ? <FontAwesomeIcon fixedWidth icon={icon} /> : null;
    };
    const renderLinks = () => {
        if (!links?.items?.length) return null;
        return links.items.map((link, indx) => (
            <li key={indx}>
                <a
                    href="#"
                    target={link.target}
                    className={`${prefix}-nav--link`}
                >
                    {link.icon && (
                        <span className="dorik-nav--link-icon">
                            {renderIcon(link.icon)}
                        </span>
                    )}
                    <span className="dorik-nav--link-text">{link.label}</span>
                </a>
            </li>
        ));
    };

    const renderBtns = () => {
        if (!btn?.items?.length) return null;
        return btn.items.map((item, indx) => (
            <li key={indx}>
                <a
                    href={item.url || '#'}
                    target={item.target}
                    className={`${prefix}-nav--btn ${prefix}-nav--btn-${item.id}`}
                >
                    {item.icon && (
                        <span className="dorik-nav--btn-icon">
                            {renderIcon(item.icon)}
                        </span>
                    )}
                    <span className="dorik-nav--btn-text">{item.label}</span>
                </a>
            </li>
        ));
    };

    const renderToggleIcon = () => {
        return (
            <button
                ref={btnRef}
                onClick={toggleNavbar}
                className={`${prefix}-navbar--toggle`}
                data-target={`#${prefix}NavbarCollapse`}
            >
                <FontAwesomeIcon fixedWidth icon={['fas', 'bars']} />{' '}
                {toggle?.text}
            </button>
        );
    };

    const toggleNavbar = (e) => {
        const el = navRef.current;
        const classList = el.classList;
        classList.toggle('show');
        console.dir(el.closest(`.${className}-wrapper`));

        el.closest(`.${className}-wrapper`).classList.toggle(`expended`);
    };

    const linkItems = renderLinks();
    const buttonItems = renderBtns();
    return (
        <div className={`${prefix}-navbar--wrapper ${className}-wrapper`}>
            <div className={`${prefix}-navbar ${className}`}>
                <div className={`${prefix}-navbar--brand`}>{renderBrand()}</div>
                {renderToggleIcon()}
                <div
                    ref={navRef}
                    className={`${prefix}-navbar--collapse collapse`}
                    id={`${prefix}NavbarCollapse`}
                >
                    <div className={`${prefix}-navbar--navs`}>
                        {linkItems && (
                            <ul className={`${prefix}-nav--links normalize`}>
                                {linkItems}
                            </ul>
                        )}
                        {buttonItems && (
                            <ul className={`${prefix}-nav--btns normalize`}>
                                {buttonItems}
                            </ul>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Nav;
